import {CardType} from "../../data";
import {mapSelectionNames} from "../mapSelectionNames";
import {mapMarketName} from "../mapMarketName";
import {BaseDict} from "../../blocks/EventListPresenter/dict";
import {MarketConfigType, CardItem} from "../../typings";

const HeaderNamesMapper = {
    [CardType.Multiview]: (market: MarketConfigType, dict: BaseDict, sportId: string, isMainHeading: boolean) =>
        isMainHeading
            ? mapMarketName(market, dict, sportId)
            : mapSelectionNames(market, dict),
    [CardType.American]: (market: MarketConfigType, dict: BaseDict, sportId: string) => mapMarketName(market, dict, sportId)
}

export const getHeaderNames = (config: CardItem, dict: BaseDict, sportId: string, isMainHeading: boolean = false): Array<Array<string>> => {
    const marketsNames = HeaderNamesMapper[config.cardType]
        ? config
            .markets
            .map((market) => HeaderNamesMapper[config.cardType](market, dict, sportId, isMainHeading))
        : [];
    return marketsNames;
}